import { Link } from "react-router-dom";
import { COMPLETED, IN_PROGRESS } from "../data/progressStore";
import { CheckIcon, ClockIcon, PlayIcon } from "./Icons";
import ui from "./ui.module.css";

export const lessonStateOf = (record) => record?.status || null;

// In progress first, then not started, completed last; stable otherwise.
export const orderForToday = (lessons, getProgress) => {
  const rank = (lesson) => {
    const state = lessonStateOf(getProgress(lesson.id));
    if (state === IN_PROGRESS) return 0;
    if (state === COMPLETED) return 2;
    return 1;
  };
  return lessons
    .map((lesson, index) => ({ lesson, index }))
    .sort((a, b) => rank(a.lesson) - rank(b.lesson) || a.index - b.index)
    .map(({ lesson }) => lesson);
};

export const LessonMeta = ({ lesson, extra }) => (
  <p className={ui.meta}>
    {lesson.minutes && (
      <span className={ui.metaItem}>
        <ClockIcon size={16} />
        {lesson.minutes} min
      </span>
    )}
    {extra}
  </p>
);

// One state-aware action: Start, Resume, or Completed with a way back in
// (the overview offers Teach again).
export const LessonAction = ({ lesson, record, primary }) => {
  const state = lessonStateOf(record);
  if (state === COMPLETED) {
    return (
      <span className={ui.completedAction}>
        <span className={`${ui.state} ${ui.done}`}>
          <CheckIcon />
          Completed
        </span>
        <Link
          to={`/lesson/${lesson.slug}`}
          className={`${ui.button} ${ui.secondary}`}
          aria-label={`Open ${lesson.title}`}
        >
          Open
        </Link>
      </span>
    );
  }
  const verb = state === IN_PROGRESS ? "Resume" : "Start";
  return (
    <Link
      to={`/lesson/${lesson.slug}`}
      className={`${ui.button} ${primary ? ui.primary : ui.secondary}`}
      aria-label={`${verb} ${lesson.title}`}
    >
      <PlayIcon />
      {verb}
    </Link>
  );
};

export const LessonStateText = ({ record }) => {
  const state = lessonStateOf(record);
  if (state === COMPLETED) {
    return (
      <span className={`${ui.state} ${ui.done}`}>
        <CheckIcon size={16} />
        Completed
      </span>
    );
  }
  if (state === IN_PROGRESS) {
    return (
      <span className={ui.state}>
        <PlayIcon size={16} />
        In progress
      </span>
    );
  }
  return <span className={ui.state}>Not started</span>;
};
